import { EloCategory } from '../models/elo.model';

export const findCategoryByElo = (
  categories: EloCategory[],
  elo: number,
): EloCategory | null => {
  const sortedCategories = [...categories].sort(
    (a, b) => b.minimumElo - a.minimumElo,
  );

  // An ELO below every minimum still belongs to the lowest category (losses have no
  // floor): the same rule as the backend's getCategoryForSport.
  return (
    sortedCategories.find((category) => elo >= category.minimumElo) ??
    sortedCategories[sortedCategories.length - 1] ??
    null
  );
};

export const getCategoryByElo = (
  categories: EloCategory[],
  elo: number,
): string | null => findCategoryByElo(categories, elo)?.name ?? null;
